// MIDAS V3 — History search bar (Phase 5)
//
// Port of the search bar from history-page.jsx (lines 184-200). Card-style
// container with magnifier icon + free-text input + "Ctrl K" / "⌘K" mono chip.
//
// Exposes a `forwardRef` so the parent (MidasV3Layout) can focus this input
// when the user hits Ctrl+K while already on /midas-v3/history.
//
// No MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

const IS_MAC =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad/i.test(
    navigator.userAgent || (navigator as any).platform || ""
  );
const MOD_LABEL_K = IS_MAC ? "⌘K" : "Ctrl K";

interface MidasHistorySearchV3Props {
  value: string;
  onChange: (next: string) => void;
  placeholder: string;
  ariaLabel: string;
}

const MidasHistorySearchV3 = React.forwardRef<
  HTMLInputElement,
  MidasHistorySearchV3Props
>(({ value, onChange, placeholder, ariaLabel }, ref) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginTop: 18,
        padding: "10px 14px",
        background: "var(--midas-v3-card)",
        border: "1px solid var(--midas-v3-border)",
        borderRadius: 10,
        boxShadow: "var(--midas-v3-shadow)",
      }}
    >
      <span
        aria-hidden="true"
        style={{ color: "var(--midas-v3-faint)", fontSize: 14 }}
      >
        ⌕
      </span>
      <input
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        type="text"
        style={{
          flex: 1,
          border: 0,
          outline: 0,
          background: "transparent",
          fontFamily: "inherit",
          fontSize: 14,
          color: "var(--midas-v3-ink)",
          minWidth: 0,
          padding: 0,
        }}
      />
      <span
        className="mono"
        aria-hidden="true"
        style={{
          fontSize: 10.5,
          color: "var(--midas-v3-faint)",
          padding: "2px 7px",
          border: "1px solid var(--midas-v3-border)",
          borderRadius: 4,
          background: "var(--midas-v3-bg-soft)",
          whiteSpace: "nowrap",
        }}
      >
        {MOD_LABEL_K}
      </span>
    </div>
  );
});

MidasHistorySearchV3.displayName = "MidasHistorySearchV3";

export default MidasHistorySearchV3;
